module.exports = "<button class=\"btn btn-default\" (click)=\"showDialog()\">{{title}}</button>"


//////////////////
// WEBPACK FOOTER
// C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/src/app/components/pg-renderer/item-body/item-body-panel/ipp/ipp-speaking-sample-response/ipp-speaking-sample-response.component.html
// module id = cGR7
// module chunks = 1